module.exports = __webpack_public_path__ + "img/dosificacion_5.53b2fb64.png";